<script setup>
import BlockContent from '../UI/Content/BlockContent.vue'
import MediaList from '../UI/Media/MediaList.vue'
import MediaListItem from '../UI/Media/MediaListItem.vue'

const props = defineProps({
  quotationStats: {
    type: Object,
    default: () => ({
      study: 0,
      accepted: 0,
      waiting: 0,
      refused: 0,
      canceled: 0,
    }),
  },
  quotationAmounts: {
    type: Object,
    default: () => ({
      study: 0,
      accepted: 0,
      waiting: 0,
      refused: 0,
      canceled: 0,
    }),
  },
  marketTypeId: {
    type: [String, Number],
    default: null,
  },
})

function buildHref(status) {
  let href = `simulations/index.php?s=${status}`
  if (props.marketTypeId) {
    href += `&marketType=${props.marketTypeId}`
  }
  return href
}
</script>

<template>
  <BlockContent
    icon="fas fa-calculator"
    title-t="home.dashboardSimulation.title"
    title-level="5"
    color="info"
    e2e-block="homeDashboardSimulation"
  >
    <div class="row">
      <div class="col-md-12">
        <MediaList>
          <MediaListItem
            :href="buildHref(1)"
            class-badge="badge-secondary"
            :text-badge="quotationStats.waiting"
            :amount-badge="quotationAmounts.waiting"
            e2e-row="homedDashboardSimulationWaiting"
          >
            {{ $t('home.dashboardSimulation.status.waiting') }}
          </MediaListItem>
          <MediaListItem
            :href="buildHref(2)"
            class-badge="badge-info"
            :text-badge="quotationStats.study"
            :amount-badge="quotationAmounts.study"
            e2e-row="homedDashboardSimulationStudy"
          >
            {{ $t('home.dashboardSimulation.status.study') }}
          </MediaListItem>
          <MediaListItem
            :href="buildHref(3)"
            class-badge="badge-success"
            :text-badge="quotationStats.accepted"
            :amount-badge="quotationAmounts.accepted"
            e2e-row="homedDashboardSimulationAccepted"
          >
            {{ $t('home.dashboardSimulation.status.accepted') }}
          </MediaListItem>
          <MediaListItem
            :href="buildHref(5)"
            class-badge="badge-danger"
            :text-badge="quotationStats.refused"
            :amount-badge="quotationAmounts.refused"
            e2e-row="homedDashboardSimulationRefused"
          >
            {{ $t('home.dashboardSimulation.status.refused') }}
          </MediaListItem>
          <MediaListItem
            :href="buildHref(6)"
            class-badge="badge-secondary"
            :text-badge="quotationStats.canceled"
            :amount-badge="quotationAmounts.canceled"
            e2e-row="homedDashboardSimulationCanceled"
          >
            {{ $t('home.dashboardSimulation.status.canceled') }}
          </MediaListItem>
        </MediaList>
      </div>
    </div>
  </BlockContent>
</template>
